/**
 * Marker for API errors that are EXPECTED to fail — the not-yet-real mock REST
 * endpoints (see api/http.ts) that the live backend does not implement yet and
 * returns 404/405 for. These failures are acceptable (the UI degrades to empty
 * / MQTT-derived data), so they must never reach Sentry and paint a false
 * picture of app health.
 *
 * Tagged in `api/http.ts` (every error from the shared `http` instance) and
 * dropped in `lib/sentry.ts` `beforeSend`. Keying off the actual Error object
 * (via Sentry's `hint.originalException`) means the drop holds no matter how the
 * error surfaces — unhandled rejection, error boundary, or an explicit capture.
 *
 * When an endpoint graduates to a real backend, move its call onto its own
 * client (as `custodian.ts` / `partnerships.ts` already did) so its errors flow
 * to Sentry again.
 */

const MARK = '__flysafeExpectedApiError';

export function markExpectedApiError(error: unknown): void {
  if (error && typeof error === 'object') {
    (error as Record<string, unknown>)[MARK] = true;
  }
}

export function isExpectedApiError(error: unknown): boolean {
  return Boolean(error && typeof error === 'object' && (error as Record<string, unknown>)[MARK]);
}
